import script from "./ProfileRuleContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileRuleContent.vue?vue&type=script&setup=true&lang=js"

import "./ProfileRuleContent.vue?vue&type=style&index=0&id=3b424a45&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b424a45"]])

export default __exports__